import React, { Component } from "react";
import { Redirect, Link } from 'react-router-dom';
import ReactFullpage from '@fullpage/react-fullpage';
import styles from '../assets/scss/modules/kampany.module.scss';
import twitter from "../assets/media/images/Twitter.png";
import tiktok from "../assets/media/images/Tiktok.png";
import instagram from "../assets/media/images/Instagram.png";
import facebook from "../assets/media/images/Facebook.png";
import jogasz from "../assets/media/images/jogasz.png";
import kepviselo from "../assets/media/images/kepviselo.png";
import csalad from "../assets/media/images/csalad.png";
import asset1 from "../assets/media/images/asset1.png";
import asset2 from "../assets/media/images/asset2.png";
import asset3 from "../assets/media/images/asset3.png";
import asset4 from "../assets/media/images/asset4.png";
import asset5 from "../assets/media/images/Titles/kornyezetunkMegovasa.png";
import back_btn from "../assets/media/newicons/back.png";
import back_btn_black from "../assets/media/newicons/back-black.png";
import forward_btn_black from "../assets/media/newicons/nextBlue.png";
import forward_btn from "../assets/media/newicons/forward.png";
import erikfoto from "../assets/media/images/Erik-foto.png";
import bild from "../assets/media/images/ProgramImages/KornyezetunkMegovasa.jpg";
import konczer_facebook from "../assets/media/images/konczer-facebook.png";
import gradiensProgram from "../assets/media/images/gradiensProgram.png";
import Footer from "../components/Footer/Footer";
import FooterResponziv from "../components/Footer/FooterResponziv";
import BackComponent from "../components/Kiegeszitok/BackComponent";
import BackComponentRespo from "../components/Kiegeszitok/BackComponentRespo";
import NavbarComponent from "../NavbarComponent";
import { Scrollbar } from "react-scrollbars-custom";


import{
	MDBContainer,
  MDBScrollbar,
	MDBRow,
	MDBCol,
	MDBCard,
	MDBCardHeader,
	MDBCardBody,
  MDBBtn,
} from 'mdbreact';

class KornyezetunkMegovasa extends Component {

	constructor(props) {
		super(props);
		this.state = {navbarPaddingTop: true,
									};
	};

	componentDidMount() {
		document.addEventListener("scroll", this.scrollEventListener);
	}

	componentWillUnmount() {
	}

	scrollEventListener = (event) => {
		const navPadding = window.scrollY < 100 ? true : false;
		this.setState({ navbarPaddingTop: navPadding});
	}


	render() {
		const anchors = ["program1", "program2", "program3"];
		let bodywrapperHeight = parseInt(window.outerWidth*0.8 + 100);
		let bodywrapperHeightText = bodywrapperHeight + "px";
    return (
			<>
			<MDBContainer fluid className="fluid-container">
				<div className="d-none d-lg-block">
					<div className={styles.bodywrapper7}>
						<BackComponent text={"EpitettTermeszetiOrokseg"} text2={"Épített és természeti örökség"} program={"program5"}/>
						<img className="bild" src={bild}></img>
						<MDBContainer fluid className="program-container-programok">
							<Scrollbar
												id="scrollbar"
												style={{ width: "100%", height: "76vh", marginTop: "-5vh"}}
												maximalThumbYSize = {50}
												noScrollX = {true}
							>
								<MDBContainer fluid className="section" id="program">
									<div className={styles.bodywrapper3}>
										<MDBRow  center className="program-text-row">
										</MDBRow>
										<MDBRow  center className="program-text-row">
											<p className="jelenleg-is-ont-kepv">A természet és mi - környezetünk megóvása</p>
											<p className="a-megyei-kozgyulesbe">Jelentős területek vannak a környéken (Mésztelepi iparterület,
												Alumínium kohó melletti részek, Bánhidai Erőmű, Márgabánya) amelyeket rekultiválni,
												illetve fejleszteni kell. Ezzel a zöldmezős beruházások által igénybe vett termőföldeket is kímélhetjük,
												ezért napelemparkokkal segítjük a barnamezős területek rekultivációját!
												A fenntartható fejlődést szem előtt tartva végzünk minden fejlesztést!</p>
												<p className="a-megyei-kozgyulesbe">A természetes vizeink apadásának egyik oka a klímaváltozás,
												a másik viszont az emberi tényező. Sokkal gyorsabban használjuk fel a forrásainkat,
												</p>
												<p className="a-megyei-kozgyulesbe">mint ahogy azokat pótolni tudná a természet. Miközben az ipar vízigénye is egyre nő,
												az új beruházások esetén a környezetterhelés nem elsődleges szempont a jelenlegi hatalomnak.
												Pedig a tatai karsztvizekből akár napi 10 000 m3-t vihetek el ipari célokra, csak azért,
												mert a hatósági előírások az emberek helyett a gyárak kedvére tesznek. Eközben előlünk, lakosok elől titkolják az új beruházások környezetterhelési következményeit.
												Csak olyan ipari beruházást engedélyezünk településeinken, amely megfelel a leginkább
												környezetet óvó, modern eljárásoknak! Szélesítjük az engedélyezés társadalmi kontrollját!
												</p>
												<p className="a-megyei-kozgyulesbe">Míg a városokat a közlekedés, a vidéki településeket a téli fűtés szennyezi.
												A térségben az elmúlt öt évben több,
												</p>
										</MDBRow>
										<MDBRow  center className="program-text-row-end">
											<p className="a-megyei-kozgyulesbe">mint harmadával nőtt a légúti megbetegedések száma.
											Tatabányán félbehagyott és megoldatlan probléma az azbesztmentesítés:
											Sárberek egésze és Dózsakert egy része is veszélyeztetett. Mindezek miatt elvégezzük az azbesztmentesítést,
											általános fűtéskorszerűsítési támogatást teszünk elérhetővé! Az egyre szélsőségesebb meleghullámokból következő extrém városi hőérzetet
											az aszfaltozott terek helyett, a virágos zöld területek, parkok teszik komfortosabbá.
											E folyamatban egyszerre kell az őshonos növényi kultúrát megóvni és a klímaváltozás miatt új fajokat beilleszteni.
											A zöld területek védelme érdekében intenzív városi fásítási programot indítunk,
											illetve előírjuk, hogy a parkolóépítések esetében nem csökkenhet a zöld felület!</p>
											<p className="a-megyei-kozgyulesbe">Az illegális hulladéklerakás komoly környezetterhelést jelent,
											élhetetlenné teszi a településeket és veszélyes az egészségre is, ezért kiemelt figyelmet érdemel a megszüntetése.
											A társadalmi együttélés érdekében sokkal komolyabban fogjuk szankcionálni az illegális hulladéklerakást!</p>
										</MDBRow>

									</div>
							</MDBContainer>

						</Scrollbar>
					</MDBContainer>
					<div className="fixed-bottom d-none d-lg-block">
					<div className="gradient"/>
						<Footer/>
					</div>
				</div>
				</div>
			</MDBContainer>

			<div className="d-block d-lg-none">
				<MDBContainer fluid className="fluid-container">
					<div className={styles.bodywrapper4}>
						<BackComponentRespo navbarPaddingTop={this.state.navbarPaddingTop} text={"EpitettTermeszetiOrokseg"} program={"program5"}/>
						<img className="bild2" src={bild}></img>
					</div>
					<div className={styles.bodywrapper3}>
						<img className="asset5-respo" src={asset5}></img>
						<MDBRow  center className="program-text-row m-0 px-3">
						<p className="jelenleg-is-ont-kepv">A természet és mi - környezetünk megóvása</p>
						<p className="a-megyei-kozgyulesbe">Jelentős területek vannak a környéken (Mésztelepi iparterület,
							Alumínium kohó melletti részek, Bánhidai Erőmű, Márgabánya) amelyeket rekultiválni,
							illetve fejleszteni kell. Ezzel a zöldmezős beruházások által igénybe vett termőföldeket is kímélhetjük,
							ezért napelemparkokkal segítjük a barnamezős területek rekultivációját!
							A fenntartható fejlődést szem előtt tartva végzünk minden fejlesztést!</p>
							<p className="a-megyei-kozgyulesbe">A természetes vizeink apadásának egyik oka a klímaváltozás,
							a másik viszont az emberi tényező. Sokkal gyorsabban használjuk fel a forrásainkat,
							</p>
							<p className="a-megyei-kozgyulesbe">mint ahogy azokat pótolni tudná a természet. Miközben az ipar vízigénye is egyre nő,
							az új beruházások esetén a környezetterhelés nem elsődleges szempont a jelenlegi hatalomnak.
							Pedig a tatai karsztvizekből akár napi 10 000 m3-t vihetek el ipari célokra, csak azért,
							mert a hatósági előírások az emberek helyett a gyárak kedvére tesznek. Eközben előlünk, lakosok elől titkolják az új beruházások környezetterhelési következményeit.
							Csak olyan ipari beruházást engedélyezünk településeinken, amely megfelel a leginkább
							környezetet óvó, modern eljárásoknak! Szélesítjük az engedélyezés társadalmi kontrollját!
							</p>
							<p className="a-megyei-kozgyulesbe">Míg a városokat a közlekedés, a vidéki településeket a téli fűtés szennyezi.
							A térségben az elmúlt öt évben több,
							</p>
						</MDBRow>
						<MDBRow  center className="program-text-row-end m-0 px-3">
						<p className="a-megyei-kozgyulesbe">mint harmadával nőtt a légúti megbetegedések száma.
						Tatabányán félbehagyott és megoldatlan probléma az azbesztmentesítés:
						Sárberek egésze és Dózsakert egy része is veszélyeztetett. Mindezek miatt elvégezzük az azbesztmentesítést,
						általános fűtéskorszerűsítési támogatást teszünk elérhetővé! Az egyre szélsőségesebb meleghullámokból következő extrém városi hőérzetet
						az aszfaltozott terek helyett, a virágos zöld területek, parkok teszik komfortosabbá.
						E folyamatban egyszerre kell az őshonos növényi kultúrát megóvni és a klímaváltozás miatt új fajokat beilleszteni.
						A zöld területek védelme érdekében intenzív városi fásítási programot indítunk,
						illetve előírjuk, hogy a parkolóépítések esetében nem csökkenhet a zöld felület!</p>
						<p className="a-megyei-kozgyulesbe">Az illegális hulladéklerakás komoly környezetterhelést jelent,
						élhetetlenné teszi a településeket és veszélyes az egészségre is, ezért kiemelt figyelmet érdemel a megszüntetése.
						A társadalmi együttélés érdekében sokkal komolyabban fogjuk szankcionálni az illegális hulladéklerakást!</p>
						</MDBRow>
					</div>
				</MDBContainer>
				<MDBContainer fluid className="fluid-container">
					<div className={styles.bodywrapper5}>
						<FooterResponziv/>
					</div>
				</MDBContainer>
			</div>
      </>
    );
  }
}
export default  KornyezetunkMegovasa;
